import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchRevenueStats } from '../../services/adminService';

const RevenueChart = ({ ticketsData = [] }) => {
    const [realTickets, setRealTickets] = useState(ticketsData);

    useEffect(() => {
        if (Array.isArray(ticketsData) && ticketsData.length > 0) {
            setRealTickets(ticketsData);
        } else {
            fetchRevenueStats().then(res => {
                if (res && res.ok && Array.isArray(res.data)) {
                    setRealTickets(res.data);
                } else if (Array.isArray(res?.data)) {
                    setRealTickets(res.data);
                }
            }).catch(err => console.error(err));
        }
    }, [ticketsData]);

    // Weekday labels: T2 (Mon) to CN (Sun)
    const daysMap = [
        { key: 1, day: 'T2', revenue: 0 },
        { key: 2, day: 'T3', revenue: 0 },
        { key: 3, day: 'T4', revenue: 0 },
        { key: 4, day: 'T5', revenue: 0 },
        { key: 5, day: 'T6', revenue: 0 },
        { key: 6, day: 'T7', revenue: 0 },
        { key: 0, day: 'CN', revenue: 0 },
    ];

    // Compute real revenue for past 7 days
    const sevenDaysAgo = new Date(Date.now() - 7 * 86400000);
    if (Array.isArray(realTickets) && realTickets.length > 0) {
        realTickets.forEach(ticket => {
            const timeVal = ticket.timeOut || ticket.timeIn || ticket.createdAt;
            if (ticket.price && timeVal) {
                const date = new Date(timeVal);
                if (date >= sevenDaysAgo) {
                    const dayIndex = date.getDay(); // 0 is Sun, 1 is Mon
                    const target = daysMap.find(d => d.key === dayIndex);
                    if (target) {
                        target.revenue += parseInt(ticket.price || 0, 10);
                    }
                }
            }
        });
    }

    const totalRevenue = daysMap.reduce((sum, item) => sum + item.revenue, 0);
    const maxRevenue = Math.max(...daysMap.map(item => item.revenue)) || 100000;

    const formatCurrency = (amount) => {
        return amount.toLocaleString('vi-VN') + ' đ';
    };

    return (
        <div className="revenue-chart">
            <div className="chart-info mb-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div>
                        <h6 className="mb-1 text-dark fw-bold">Tổng Doanh Thu Thực Tế (7 Ngày)</h6>
                        <p className="text-muted small mb-0">Cập nhật tự động từ lượt xe & đăng ký gói thành viên</p>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <div className="text-end">
                            <h5 className="text-success fw-bold mb-0">
                                {formatCurrency(totalRevenue)}
                            </h5>
                            <small className="text-muted">Tổng 7 ngày</small>
                        </div>
                        <Link to="/admin/revenue" className="btn btn-outline-primary btn-sm rounded-pill px-3 fw-semibold shadow-xs">
                            <i className="bi bi-file-earmark-bar-graph me-1"></i> Xem chi tiết & Báo cáo
                        </Link>
                    </div>
                </div>
            </div>

            <div className="chart-container bg-light rounded-3 p-4 border">
                <div className="chart-bars d-flex align-items-end justify-content-between" style={{ height: '180px' }}>
                    {daysMap.map((item, index) => {
                        const barHeight = maxRevenue > 0 ? Math.max((item.revenue / maxRevenue) * 140, 12) : 12;
                        return (
                            <div key={index} className="chart-bar-container text-center flex-grow-1 mx-1">
                                <div
                                    className="chart-bar position-relative rounded-top"
                                    style={{
                                        height: `${barHeight}px`,
                                        background: item.revenue > 0 
                                            ? 'linear-gradient(180deg, #0d6efd 0%, #1d4ed8 100%)' 
                                            : '#e2e8f0',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    title={`${item.day}: ${formatCurrency(item.revenue)}`}
                                ></div>
                                <div className="chart-label mt-2">
                                    <small className="text-secondary fw-semibold">{item.day}</small>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default RevenueChart;
